import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CustomerView } from './panes/customer-view';
import { FeatureFlagsView } from './panes/feature-flags-view';
import React from 'react';
import { Tabs } from 'antd';
const tabItems = [
    {
        children: React.createElement(CustomerView, null),
        key: '1',
        label: COPY_SPECIFIC.CUSTOMER_VIEW
    },
    {
        children: React.createElement(FeatureFlagsView, null),
        key: '2',
        label: COPY_SPECIFIC.FEATURE_FLAGS
    }
];
export const AdminDashboardTabs = ({ id }) => React.createElement(Tabs, { id: id, items: tabItems });
